// 华为云OBS配置
// 警告：密钥不应直接暴露在前端代码中
// 建议：通过后端API获取临时STS Token
export const h = {
  access_key_id: process.env.REACT_APP_OSS_ACCESS_KEY_ID || '',
  secret_access_key: process.env.REACT_APP_OSS_SECRET_ACCESS_KEY || '',
  server: process.env.REACT_APP_OSS_SERVER || 'obs.cn-south-1.myhuaweicloud.com',
}

// MQTT配置
export const mqttConfig = {
  url: process.env.REACT_APP_MQTT_URL || 'wss://3dmetahub.com/mqtt',
  username: process.env.REACT_APP_MQTT_USERNAME || 'metahub',
  password: process.env.REACT_APP_MQTT_PASSWORD || '',
  reconnectPeriod: 1000,
  connectTimeout: 30 * 1000,
}

// CDN配置
export const cdnUrl = process.env.REACT_APP_CDN_URL || 'https://3dmetahub.com'

// 火山云TOS配置
export const tosConfig = {
  baseUrl: process.env.REACT_APP_TOS_BASE_URL || 'https://use-public.tos-cn-shanghai.volces.com/',
}

// 功能开关
export const features = {
  analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  sentry: process.env.REACT_APP_ENABLE_SENTRY === 'true',
}